import React from 'react';
import { connect } from '@souche-f2e/muji';
import styles from './Docs.module.less';
import Demon from './Demon';
import { MujiLink } from '@souche-f2e/muji'
import { Col, Row, Anchor, Icon, Dropdown, Menu } from 'antd';
import MarkDownJson from './MarkDownJson';
import MarkDown from './MarkDown';
import mdStyles from './markdown.module.less';

// 异步回调数据格式
function ReturnCbDocs({ api = {} }) {
  if (api.isCallback) {
    return (
      <div>
        <h2>异步回调格式</h2>
        <MarkDownJson json={api.returnCbParams} />
        <h2>异步回调文档</h2>
        <MarkDown docs={api.callbackDoc} />
      </div>
    )
  }
  return <div></div>
}

function ReturnCbDocsAnchor({ api = {} }) {
  if (api.isCallback) {
    return (
      <div>
        <Anchor.Link href="callback-format" title="异步回调格式" />
        <Anchor.Link href="callback-docs" title="异步回调文档" />
      </div>
    )
  }
  return <div></div>
}


function Docs(props = {}) {
  const { api, inParamsTable } = props;

  if (!api || !api.id) {
    return (
      <div>
        载入中...
      </div>
    )
  }

  const menu = (
    <Menu>
      <Menu.Item>
        <MujiLink to="/documents/docs">预发 / 生产文档</MujiLink>
      </Menu.Item>
      <Menu.Item>
        <MujiLink to="/documents/stable_docs">测试 / Stable文档</MujiLink>
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
      <Row gutter={8}>
        <Col span={20} >
          <h1 style={{ maxWidth: '1200px', wordBreak: 'break-all' }}>{`${api.uri}`}</h1>
          <h1 style={{ maxWidth: '1200px', color: '#835e1d' }}>{`${api.name}`}</h1>

          {/* 请求地址 */}
          <div>
            <h2 id="query-address">请求地址</h2>
            <div style={{ marginBottom: '8px' }}>
              <p style={{ display: 'inline' }}>测试环境</p>
              <blockquote style={{ display: 'inline', marginLeft: '20px' }} className={styles.quote}>
                <span>
                  <code className={styles.url}>{`${'POST'} ${process.env.MUJI_APP_DARTS_DEV}/${api.version}`}</code>
                </span>
              </blockquote>
            </div>
            <div style={{ marginBottom: '8px' }}>
              <p style={{ display: 'inline' }}>预发环境</p>
              <blockquote style={{ display: 'inline', marginLeft: '20px' }} className={styles.quote}>
                <span>
                  <code className={styles.url}>{`${'POST'} ${process.env.MUJI_APP_DARTS_PREPUB}/${api.version}`}</code>
                </span>
              </blockquote>
            </div>
            <div style={{ marginBottom: '8px' }}>
              <p style={{ display: 'inline' }}>正式环境</p>
              <blockquote style={{ display: 'inline', marginLeft: '20px' }} className={styles.quote}>
                <span>
                  <code className={styles.url}>{`${'POST'} ${process.env.MUJI_APP_DARTS_PROD}/${api.version}`}</code>
                </span>
              </blockquote></div>
          </div>

          {/* 公共参数 */}
          <div className={mdStyles.markdown}>
            <h2 id="public-parameters">公共参数</h2>
            <table style={{ marginBottom: '10px' }}>
              <thead>
                <tr><th>字段</th><th>类型</th><th>是否必须</th><th>描述</th></tr>
              </thead>
              <tbody>
                <tr><td>appKey</td><td>String</td><td>✔</td><td>appKey</td></tr>
                <tr><td>timestamp</td><td>Number</td><td>✔</td><td>秒级别时间戳</td></tr>
                <tr><td>sign</td><td>String</td><td>✔</td><td>签名，具体方式参考 <MujiLink to="/documents/docking_process?docId=1">{'<认证鉴权>'}</MujiLink></td></tr>
              </tbody>
            </table>
          </div>

          {/* 请求格式 */}
          <div>
            <h2 id="query-format">请求格式</h2>
            <Demon api={api} />
          </div>

          {/* 入参规则 */}
          <div className={mdStyles.markdown}>
            <h2 id="input-params">入参规则</h2>
            <div style={{ marginBottom: '10px' }} dangerouslySetInnerHTML={{ __html: inParamsTable }} />
          </div>

          {/* 出参格式 */}
          <div>
            <h2 id="output-format">出参格式</h2>
            <MarkDownJson json={api.returnParams} />
          </div>

          {/* 出参文档 */}
          <div>
            <h2 id="output-docs">出参文档</h2>
            <MarkDown docs={api.doc} />
            {ReturnCbDocs({ api })}
          </div>
        </Col>

        <Col span={4}>
          <div style={{ borderBottom: '1px solid #e8e8e8', marginBottom: '50px', paddingBottom: '0px' }}>
            <Dropdown overlay={menu}>
              <div>
                <div style={{fontSize: '1.3em'}}>
                  <Icon type="swap" /> 切换环境
                </div>
                <div>
                  当前: 测试 / Stable文档
                </div>
              </div>
            </Dropdown>
          </div>
          <Anchor>
            <Anchor.Link href="#query-address" title="请求地址" />
            <Anchor.Link href="#public-parameters" title="公共参数" />
            <Anchor.Link href="#query-format" title="请求格式" />
            <Anchor.Link href="#input-params" title="入参规则" />
            <Anchor.Link href="#output-format" title="出参格式" />
            <Anchor.Link href="#output-docs" title="出参文档" />
            {ReturnCbDocsAnchor(api)}
          </Anchor>
        </Col>

      </Row>
    </div>
  )
}

export default Docs;